import { render, staticRenderFns } from "./PerformanceLog.vue?vue&type=template&id=2df66830&scoped=true"
import script from "./PerformanceLog.vue?vue&type=script&lang=js"
export * from "./PerformanceLog.vue?vue&type=script&lang=js"
import style0 from "./PerformanceLog.vue?vue&type=style&index=0&id=2df66830&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df66830",
  null
  
)

export default component.exports